// store/workflows/safetyFormWorkflow/action.js

import {
  submitNearMissForm as apiSubmitNearMissForm,
  submitSafetyAuditChecklistForm as apiSubmitSafetyAuditForm,
  deleteNearMissForm as apiDeleteNearMissForm,
  deleteSafetyAuditForm as apiDeleteSafetyAuditForm,
} from "../../../api/SafetyFormApi";

export const makeSafetyFormWorkflowActions = (set, get) => ({
  // Near Miss Actions

  // Near Miss Submit (simplified - data already saved via WebSocket autosave)
  submitNearMiss: async (nearMissDataModel, userContext) => {
    const { notificationActions, safetyFormListsActions } = get();

    // Use simplified method - data already saved via autosave
    const payload = nearMissDataModel.submitNearMissSimple(userContext);
    if (payload?.errors) {
      // Model already set fieldErrors internally; payload.errors contains notificationErrors
      return { ok: false, nearMissErrors: payload.errors };
    }

    try {
      const res = await apiSubmitNearMissForm(payload);
      if (res?.success) {
        safetyFormListsActions.removeNearMissDraftLocal(nearMissDataModel.id);
        // Clear errors on successful submit
        nearMissDataModel.errors = null;
      }
      return { ok: !!res?.success };
    } catch (err) {
      console.error("submitNearMiss error", err);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "A network error occurred while submitting your near miss. Please try again.";
      notificationActions.showNotification({
        type: "error",
        title: "Error Submitting Near Miss",
        message: msg,
      });
      return { ok: false, error: err };
    }
  },

  // Near Miss Delete
  deleteNearMiss: async (nearMissId) => {
    const { notificationActions, safetyFormListsActions } = get();
    try {
      const res = await apiDeleteNearMissForm(nearMissId);
      if (res?.success) {
        safetyFormListsActions.removeNearMissDraftLocal(nearMissId);
      }
      return { ok: !!res?.success };
    } catch (err) {
      console.error("deleteNearMiss error", err);
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "A network error occurred while deleting your near miss. Please try again.";
      notificationActions.showNotification({
        type: "error",
        title: "Error Deleting Near Miss",
        message: msg,
      });
      return { ok: false, error: err };
    }
  },

  // Safety Audit Form Actions

  // Safety Audit Form Submit (simplified - data already saved via WebSocket autosave)
  submitSafetyAudit: async (safetyAuditDataModel, userContext) => {
    const { notificationActions, safetyFormListsActions } = get();

    // Use simplified method - data already saved via autosave
    const payload = safetyAuditDataModel.submitSafetyAuditSimple(userContext);
    if (payload?.errors) {
      // Model already set fieldErrors internally; payload.errors contains notificationErrors
      return { ok: false, safetyAuditErrors: payload.errors };
    }

    try {
      const res = await apiSubmitSafetyAuditForm(payload);
      if (res?.success) {
        safetyFormListsActions.removeSafetyAuditDraftLocal(
          safetyAuditDataModel.id
        );
        // Clear errors on successful submit
        safetyAuditDataModel.errors = null;
      }
      return { ok: !!res?.success };
    } catch (err) {
      console.error("submitSafetyAudit error", err);
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "A network error occurred while submitting your safety audit. Please try again.";
      notificationActions.showNotification({
        type: "error",
        title: "Error Submitting Safety Audit",
        message: msg,
      });
      return { ok: false, error: err };
    }
  },

  // Safety Audit Form Delete
  deleteSafetyAudit: async (safetyAuditId) => {
    const { notificationActions, safetyFormListsActions } = get();
    try {
      const res = await apiDeleteSafetyAuditForm(safetyAuditId);
      if (res?.success) {
        safetyFormListsActions.removeSafetyAuditDraftLocal(safetyAuditId);
      }
      return { ok: !!res?.success };
    } catch (err) {
      console.error("deleteSafetyAudit error", err);
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "A network error occurred while deleting your safety audit. Please try again.";
      notificationActions.showNotification({
        type: "error",
        title: "Error Deleting Safety Audit",
        message: msg,
      });
      return { ok: false, error: err };
    }
  },
});
